<template>
    <div class="pricing-card">
      <div class="pricing-content">
        <div class="free-months-badge" v-if="currentSelectedPlan.durationCode === 'P1Y'">
          <span :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getOriginalSavePrice(currentSelectedPlan.promoTitle) }}</span>
          <img src="../assets/images/gift.svg" alt="''"/>
        </div>
        <div class="pricing-details">
          <div class="duration">{{$t(currentSelectedPlan.planId)}}</div>
          <div class="price">
            <!-- <p class="trial-text">{{ dispalyYearlyPriceInLabel('register_page_box_subtitle_yearly') }}</p> -->
            <!-- <span v-if="currentSelectedPlan.durationCode === 'P1Y'" class="original-price">{{ getOriginalPrice()}}</span> -->
            <span v-if="currentSelectedPlan.durationCode === 'P1Y'" class="discounted-price" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getYearlyPrice('register_page_box_subtitle_yearly') }}</span>
            <!-- <span v-if="currentSelectedPlan.durationCode === 'P1Y'" class="period">/ {{ $t('subscription_view_new_year') }}</span> -->
            <span v-else class="period" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ getMonthlyPrice() }}</span>
          </div>
        </div>
      </div>
      <button class="arrow-button" @click.prevent="handleClick">
        <img class="arrow" src="../assets/images/arrow-right.svg?url" alt="proceed"  />
      </button>
    </div>
  </template>
  
  <script>
  import PriceMixin from '../mixins/price';
  import { mapGetters } from 'vuex';
  export default {
    name: 'PricingCard',
		mixins: [PriceMixin],
    computed: {
      ...mapGetters(['getCurrentSelectedPlan']),
      currentSelectedPlan() { 
        return this.getCurrentSelectedPlan;
      },
    },
    methods: {
      handleClick() {
        this.$emit('togglePricingModal');
      }
    }
  }
  </script>
  
  <style scoped>
  .pricing-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #020076;
    border-radius: 13px;
    padding: 12px 12px;
    color: white;
    width: 100%;
    position: relative;
	font-family: "Nunito-Regular";
    
    @media (orientation: portrait) {
        max-width: 100%;
    }
  }
  
  .pricing-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-family: "Nunito-Regular";
  }
  .pricing-details {
    font-family: "Nunito-Regular";
    text-align: left;
  }
  .free-months-badge {
    font-family: "Nunito-Regular";
    background-color: #FFA726;
    color: #020076;
    font-weight: bold;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
    margin-bottom: 4px;
    width: fit-content;
    display: flex;
    flex-direction: row;
    gap: 5px;
  }
  
  .duration {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 2px;
    font-family: "Nunito-ExtraBold";
  }
  
  .price {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
  }
  
  .original-price {
    text-decoration: line-through;
    opacity: 0.8;
  }
  
  .discounted-price {
    font-weight: bold;
    font-size: 16px;
  }
  
  .period {
    opacity: 0.8;
  }
  
  .arrow-button {
    width: 50px;
    height: 50px;
    padding: 10;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
    img {
      width: 40%;
      height: auto;
      filter: brightness(0) invert(1); /* Converts to white */
      padding-left: 3px;
      padding-bottom: 0px;
      padding-top: 3px;
    }
  }
  
  .arrow-button:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
  
  .arrow {
    color: white;
    font-size: 40px;
    line-height: 1;
    margin-top: -2px;
  }
  </style>